module.exports = __webpack_public_path__ + "img/8f76761e9986b01a6aad3239290dd58a.png";


//////////////////
// WEBPACK FOOTER
// ./classes/items/rice/assets/sprites/rice.png
// module id = 74
// module chunks = 0